import styled from 'styled-components';
import { GiftOutlined } from '@ant-design/icons';

export const GiftIcon = styled(GiftOutlined)`
  font-size: 10px;
  color: #f78e1e;
`;
